

import React, { memo } from 'react';
import cx from 'classnames';

import Checkbox from '../Checkbox';
import Button from '../Button';
import Text from '../Text';
import './_bulk-actions.scss';



















function withSuffix(string, suffix) {
  if (!suffix) {return string;}

  return `${string} ${suffix}`;
}

// Make sure all selected items have the right permission for the action
const hasInvalidPermissions = (selectedItemsData, requiredPermission) =>
{
  if (!requiredPermission) {return false;}

  return selectedItemsData.
  some((item) => Boolean(!item.permissions || !item.permissions.includes(requiredPermission)));
};

function BulkActions({
  totalItems,
  selectedItems,
  actions,
  onSelectAll,
  onSelectAction,
  darkMode,
  suffix,
  selectedItemsData,
  totalResults
}) {
  if (!totalItems) {return null;}

  const everythingSelected = totalItems === selectedItems;
  const displayTotal = totalResults && totalResults > totalItems ? totalResults : totalItems;
  const hasMoreToLoad = totalResults && totalResults > totalItems;
  const itemLabel = (suffix || 'items').toLowerCase();

  return (
    <div
      className={cx(
        'bulk-actions',
        {
          'bulk-actions--partial': !everythingSelected && selectedItems,
          'bulk-actions--dark-mode': darkMode
        }
      )}>

      <Checkbox
        checked={everythingSelected}
        onChange={onSelectAll}>

        {!selectedItems || everythingSelected ?

        <Text
          button
          noMargin>

              {`${everythingSelected ? 'Deselect' : 'Select'} All`}
            </Text> :

        null}
      </Checkbox>
      {selectedItems ?

      <div className="bulk-actions__selection-info">
            <p className="bulk-actions__selected">
              <Text button noMargin>{`${selectedItems} of ${displayTotal} ${itemLabel} selected`}</Text>
            </p>
            {hasMoreToLoad ?
        <Text
          caption
          noMargin
          className="bulk-actions__load-more-hint">

                Scroll down to load more
              </Text> :

        null}
          </div> :

      null}
      {
      selectedItems && actions && actions.length ?

      <div className="bulk-actions__actions">
              {actions.map(({ icon, action, requiredPermission, label }) => {
          const isDisabled = hasInvalidPermissions(selectedItemsData, requiredPermission);

          return typeof icon === 'string' ?

          <Button
            prefix={icon}
            key={icon}
            type="TERTIARY"
            disabled={isDisabled}
            onClick={isDisabled ?
            void 0 :
            onSelectAction && onSelectAction(action) || action}

            tooltipLabel={label}
            tooltipId={icon} /> :


          icon;
        })}
            </div> :

      null}

    </div>);

}

export default memo(BulkActions);